var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0417 5.54163H3.95833C3.08388 5.54163 2.375 6.25051 2.375 7.12496V14.25C2.375 15.1244 3.08388 15.8333 3.95833 15.8333H15.0417C15.9161 15.8333 16.625 15.1244 16.625 14.25V7.12496C16.625 6.25051 15.9161 5.54163 15.0417 5.54163Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63299 8.45358C8.3683 8.26391 8 8.45309 8 8.77872V12.0553C8 12.3797 8.36581 12.5692 8.63076 12.382L10.9336 10.7556C11.1583 10.5969 11.1594 10.264 10.9358 10.1037L8.63299 8.45358Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 2.375L9.50016 5.54167L6.3335 2.375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialIcon);
export default __webpack_public_path__ + "static/media/TutorialIcon.f5629bf9.svg";
export { ForwardRef as ReactComponent };